export type RecordPermissions = { read: boolean; create: boolean; update: boolean; delete: boolean };

export const allowsRecordAction = (action: Record<string, any>, permissions?: RecordPermissions): boolean => {
    if (!permissions) return true;
    if (action.label === "New" || action.label === "Create" || action.label === "Insert record") return permissions.create;
    if (action.label === "Delete") return permissions.delete;
    if (action.label === "Save" || action.label === "Update") return permissions.update;
    return true;
};
